(() => {
  'use strict';
  const configNode = document.getElementById('AtelierConfig');
  if (!configNode) return;
  const cfg = JSON.parse(configNode.textContent);
  const root = `${cfg.root.replace(/\/$/, '')}/`;
  const status = document.getElementById('ShopStatus');
  const money = value => new Intl.NumberFormat(cfg.locale || 'en-IN', { style: 'currency', currency: cfg.currency || 'INR' }).format(value / 100);
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const announce = text => { if (status) status.textContent = text; };
  const productCache = new Map();
  const productURL = handle => `${root}products/${encodeURIComponent(handle)}`;
  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  }
  async function productData(handle) {
    if (!/^[a-z0-9-]+$/.test(handle)) throw new Error(cfg.strings.error);
    if (!productCache.has(handle)) productCache.set(handle, request(`${productURL(handle)}.js`).catch(error => { productCache.delete(handle); throw error; }));
    return productCache.get(handle);
  }
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog[open]').forEach(open => open.close());
    dialog.showModal();
    return true;
  }
  document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }));
  let saved = [];
  try {
    const stored = JSON.parse(localStorage.getItem('peach-atelier-saved') || '[]');
    if (Array.isArray(stored)) saved = [...new Set(stored.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)))].slice(0, 100);
  } catch {}
  const updateSavedButtons = () => document.querySelectorAll('[data-save-product]').forEach(button => button.setAttribute('aria-pressed', String(saved.includes(button.dataset.saveProduct))));
  updateSavedButtons();
  function saveStyle(handle) {
    const present = saved.includes(handle);
    saved = present ? saved.filter(item => item !== handle) : [...saved, handle].slice(-100);
    try { localStorage.setItem('peach-atelier-saved', JSON.stringify(saved)); } catch {}
    updateSavedButtons();
    announce(present ? cfg.strings.unsaved : cfg.strings.saved);
  }
  let savedRender = 0;
  async function renderSaved() {
    const renderId = ++savedRender;
    const handles = [...saved];
    const container = document.querySelector('[data-saved-content]');
    container.replaceChildren();
    if (!saved.length) { container.append(element('p', 'muted', cfg.strings.savedEmpty)); return; }
    container.append(element('p', 'muted', cfg.strings.loading));
    const results = await Promise.allSettled(handles.map(productData));
    if (renderId !== savedRender) return;
    container.replaceChildren();
    results.forEach((result, index) => {
      const handle = handles[index];
      if (result.status !== 'fulfilled') {
        const missing = element('div', 'saved-card');
        missing.append(element('p', 'muted', cfg.strings.unavailable));
        const remove = element('button', '', cfg.strings.remove);
        remove.type = 'button';
        remove.addEventListener('click', () => { saveStyle(handle); renderSaved(); });
        missing.append(remove); container.append(missing); return;
      }
      const product = result.value;
      const card = element('article', 'saved-card');
      const link = element('a'); link.href = productURL(handle);
      if (product.featured_image) { const image = element('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; link.append(image); }
      link.append(element('h3', '', product.title));
      card.append(link, element('p', '', money(product.price)));
      const remove = element('button', '', cfg.strings.remove); remove.type = 'button';
      remove.addEventListener('click', () => { saveStyle(handle); renderSaved(); });
      card.append(remove); container.append(card);
    });
  }
  let cartBusy = false;
  function setCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
  }
  function renderCart(cart) {
    const container = document.querySelector('[data-cart-content]');
    container.replaceChildren();
    setCartCounts(cart);
    const footer = document.querySelector('[data-cart-footer]');
    footer.hidden = !cart.item_count;
    document.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    if (!cart.items.length) { container.append(element('p', 'drawer-empty', cfg.strings.empty)); return; }
    cart.items.forEach(item => {
      const row = element('div', 'cart-item');
      if (item.image) { const image = element('img'); image.src = item.image; image.alt = item.product_title; image.loading = 'lazy'; row.append(image); }
      const info = element('div', 'cart-item__details');
      const title = element('a'); title.href = item.url; title.append(element('h3', '', item.product_title)); info.append(title);
      if (item.variant_title) info.append(element('p', 'muted', item.variant_title));
      if (item.selling_plan_allocation) info.append(element('p', 'muted', item.selling_plan_allocation.selling_plan.name));
      info.append(element('p', 'price', money(item.final_line_price)));
      const line = element('div', 'cart-item__line');
      const input = element('input'); input.type = 'number'; input.min = '0'; input.value = item.quantity; input.setAttribute('aria-label', `${cfg.strings.quantity}: ${item.product_title}`);
      input.addEventListener('change', () => changeCart(item.key, Number(input.value), input));
      const remove = element('button', 'cart-remove', cfg.strings.remove); remove.type = 'button'; remove.addEventListener('click', () => changeCart(item.key, 0, remove));
      line.append(input, remove); info.append(line); row.append(info); container.append(row);
    });
  }
  async function refreshCart() { const cart = await request(cfg.cart); renderCart(cart); return cart; }
  async function showCart() {
    if (!openDialog('CartDialog')) { window.location.href = `${root}cart`; return; }
    const container = document.querySelector('[data-cart-content]');
    document.querySelector('[data-cart-footer]').hidden = true;
    container.replaceChildren(element('p', 'loading-state', cfg.strings.loading));
    try { await refreshCart(); } catch (error) { container.replaceChildren(element('p', 'drawer-error', error.message)); }
  }
  async function changeCart(key, quantity, control) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true; control.disabled = true;
    document.querySelector('[data-cart-content]')?.setAttribute('aria-busy', 'true');
    try {
      const cart = await request(cfg.change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      renderCart(cart);
    } catch (error) {
      await refreshCart().catch(() => {});
      const message = element('p', 'drawer-error', error.message); message.setAttribute('role', 'alert'); document.querySelector('[data-cart-content]').prepend(message);
    } finally {
      cartBusy = false; control.disabled = false; document.querySelector('[data-cart-content]')?.removeAttribute('aria-busy');
    }
  }
  async function addToCart(form) {
    const button = form.querySelector('[data-add-button]');
    const sticky = document.querySelector(`[data-sticky-add][form="${form.id}"]`);
    const errorNode = form.querySelector('[data-product-error]');
    if (button.disabled || form.getAttribute('aria-busy') === 'true') return;
    button.disabled = true; if (sticky) sticky.disabled = true;
    form.setAttribute('aria-busy', 'true'); if (errorNode) errorNode.hidden = true;
    try {
      await request(cfg.add, { method: 'POST', body: new FormData(form) });
      await showCart();
    } catch (error) {
      if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; errorNode.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      announce(error.message);
    } finally {
      form.removeAttribute('aria-busy');
      const variants = form.closest('[data-product-section]')?.querySelector('[data-product-variants]');
      const selection = form.querySelector('[data-variant-select]');
      const available = !variants || JSON.parse(variants.textContent).find(variant => String(variant.id) === selection.value)?.available;
      button.disabled = !available; if (sticky) sticky.disabled = !available;
    }
  }
  async function showQuickShop(handle) {
    if (!openDialog('QuickShopDialog')) { window.location.href = productURL(handle); return; }
    const container = document.querySelector('[data-quick-content]');
    container.replaceChildren(element('p', 'loading-state', cfg.strings.loading));
    try {
      const product = await productData(handle);
      const layout = element('div', 'quick-layout');
      if (product.featured_image) { const image = element('img'); image.src = product.featured_image; image.alt = product.title; layout.append(image); }
      const info = element('div', 'quick-info'); info.append(element('h3', '', product.title));
      const current = product.variants.find(variant => variant.available) || product.variants[0];
      const price = element('div', 'price', money(current.price)); info.append(price);
      const form = element('form'); form.method = 'post'; form.action = `${root}cart/add`; form.dataset.productForm = '';
      const label = element('label', '', cfg.strings.size); label.htmlFor = 'QuickVariant';
      const select = element('select'); select.name = 'id'; select.id = 'QuickVariant';
      product.variants.forEach(variant => { const option = element('option', '', `${variant.title} — ${money(variant.price)}${variant.available ? '' : ` · ${cfg.strings.sold}`}`); option.value = variant.id; option.disabled = !variant.available; option.selected = variant.id === current.id; select.append(option); });
      const quantity = element('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
      const error = element('p', 'form-error'); error.dataset.productError = ''; error.setAttribute('role', 'alert'); error.hidden = true;
      const button = element('button', 'button button--full', current.available ? cfg.strings.add : cfg.strings.sold); button.type = 'submit'; button.dataset.addButton = ''; button.disabled = !current.available;
      select.addEventListener('change', () => { const variant = product.variants.find(v => String(v.id) === select.value); if (!variant) return; price.textContent = money(variant.price); button.disabled = !variant.available; button.textContent = variant.available ? cfg.strings.add : cfg.strings.sold; error.hidden = true; });
      form.append(label, select, quantity, error, button);
      const details = element('a', 'text-link', cfg.strings.details || product.title); details.href = productURL(handle);
      info.append(form, details); layout.append(info); container.replaceChildren(layout);
    } catch (error) { container.replaceChildren(element('p', 'drawer-error', error.message)); }
  }
  function initProduct(scope) {
    if (scope.dataset.productReady) return;
    const variantsNode = scope.querySelector('[data-product-variants]');
    const form = scope.querySelector('[data-product-form]');
    if (!variantsNode || !form) return;
    scope.dataset.productReady = 'true';
    const variants = JSON.parse(variantsNode.textContent);
    const select = form.querySelector('[data-variant-select]');
    const pickers = form.querySelector('[data-variant-pickers]');
    const button = form.querySelector('[data-add-button]');
    const sticky = scope.querySelector('[data-sticky-product]');
    if (pickers) { pickers.hidden = false; form.querySelector('[data-native-variants]').hidden = true; }
    function setMedia(id) {
      if (!scope.querySelector(`[data-media-id="${id}"]`)) return;
      scope.querySelectorAll('[data-media-id]').forEach(pane => {
        const active = pane.dataset.mediaId === String(id); pane.classList.toggle('is-active', active);
        if (!active) { pane.querySelectorAll('video').forEach(video => video.pause()); pane.querySelectorAll('iframe').forEach(frame => { if (frame.dataset.wasActive) { frame.src = frame.src; delete frame.dataset.wasActive; } }); }
        else pane.querySelectorAll('iframe').forEach(frame => { frame.dataset.wasActive = 'true'; });
      });
      scope.querySelectorAll('[data-product-media]').forEach(thumb => { const active = thumb.dataset.productMedia === String(id); thumb.classList.toggle('is-active', active); if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
    }
    scope.querySelectorAll('[data-product-media]').forEach(thumb => thumb.addEventListener('click', event => { event.preventDefault(); setMedia(thumb.dataset.productMedia); }));
    scope.querySelectorAll('[data-image-zoom]').forEach(link => link.addEventListener('click', event => {
      const dialog = scope.querySelector('.image-zoom-dialog'); const zoomImage = dialog?.querySelector('[data-zoom-image]');
      if (!dialog || !zoomImage || typeof dialog.showModal !== 'function') return;
      zoomImage.src = link.href; zoomImage.alt = link.querySelector('img')?.alt || '';
      event.preventDefault(); openDialog(dialog.id);
    }));
    const optionFields = [...(pickers?.querySelectorAll('fieldset') || [])];
    function optionAvailability() {
      const values = optionFields.map(field => field.querySelector('input:checked')?.value);
      optionFields.forEach((field, index) => field.querySelectorAll('input').forEach(input => {
        const possible = variants.some(variant => variant.available && variant.options.every((value, optionIndex) => value === (optionIndex === index ? input.value : values[optionIndex])));
        input.closest('.option-pill').classList.toggle('is-unavailable', !possible);
      }));
    }
    function applyVariant(variant, updateURL = true) {
      const label = !variant ? cfg.strings.unavailable : variant.available ? cfg.strings.add : cfg.strings.sold;
      const error = form.querySelector('[data-product-error]'); if (error) error.hidden = true;
      button.disabled = !variant?.available || form.getAttribute('aria-busy') === 'true'; button.querySelector('span').textContent = label;
      const dynamic = form.querySelector('.shopify-payment-button'); if (dynamic) dynamic.hidden = !variant?.available;
      const availability = scope.querySelector('[data-product-availability]');
      if (availability) { availability.replaceChildren(element('span', 'availability-dot'), document.createTextNode(variant?.available ? cfg.strings.available : variant ? cfg.strings.sold : cfg.strings.unavailable)); availability.classList.toggle('is-unavailable', !variant?.available); }
      if (sticky) { sticky.querySelector('[data-sticky-add]').disabled = button.disabled; sticky.querySelector('[data-sticky-add] span').textContent = label; sticky.querySelector('[data-sticky-variant]').textContent = variant?.title || cfg.strings.unavailable; sticky.querySelector('[data-sticky-price]').textContent = variant ? money(variant.price) : ''; }
      optionAvailability();
      if (!variant) { select.value = ''; return; }
      select.value = String(variant.id);
      const price = scope.querySelector('[data-product-price]'); price.replaceChildren(document.createTextNode(money(variant.price)));
      if (variant.compare_at_price > variant.price) price.append(element('s', '', money(variant.compare_at_price)));
      const saving = scope.querySelector('[data-product-saving]'); if (saving) { saving.hidden = !(variant.compare_at_price > variant.price); saving.textContent = cfg.strings.saveAmount.replace('{{ amount }}', money(variant.compare_at_price - variant.price)); }
      const sku = scope.querySelector('[data-product-sku]'); if (sku) sku.textContent = variant.sku || '';
      const quantity = form.querySelector('input[name="quantity"]');
      const rule = variant.quantity_rule || {}; quantity.min = rule.min || 1; quantity.step = rule.increment || 1;
      if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
      if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      if (rule.max && Number(quantity.value) > rule.max) quantity.value = rule.max;
      if (variant.featured_media?.id || variant.featured_image?.id) setMedia(variant.featured_media?.id || variant.featured_image.id);
      if (updateURL) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url); }
    }
    if (pickers) pickers.addEventListener('change', () => {
      const values = optionFields.map(field => { const selected = field.querySelector('input:checked'); field.querySelector('[data-selected-option]').textContent = selected?.value || ''; return selected?.value; });
      const variant = variants.find(candidate => candidate.options.every((value, index) => value === values[index])); applyVariant(variant);
      if (variant) select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    select.addEventListener('change', () => applyVariant(variants.find(variant => String(variant.id) === select.value)));
    applyVariant(variants.find(variant => String(variant.id) === select.value), false);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0 }).observe(button);
    }
    try {
      const handle = scope.dataset.productHandle;
      const old = JSON.parse(localStorage.getItem('peach-atelier-recent') || '[]');
      const handles = Array.isArray(old) ? old.filter(value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value)) : [];
      localStorage.setItem('peach-atelier-recent', JSON.stringify([handle, ...handles.filter(value => value !== handle)].slice(0, 12)));
    } catch {}
  }
  async function initRecent(scope) {
    if (scope.dataset.recentReady) return;
    scope.dataset.recentReady = 'true';
    let handles;
    try { const history = JSON.parse(localStorage.getItem('peach-atelier-recent') || '[]'); handles = Array.isArray(history) ? [...new Set(history.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle) && handle !== scope.dataset.currentHandle))].slice(0, 4) : []; } catch { return; }
    if (!handles.length) return;
    const results = await Promise.allSettled(handles.map(productData));
    const grid = scope.querySelector('[data-recently-grid]');
    results.forEach(result => {
      if (result.status !== 'fulfilled') return;
      const product = result.value; const card = element('article', 'product-card');
      const media = element('div', 'product-card__media'); const imageLink = element('a', 'product-card__image-link'); imageLink.href = productURL(product.handle);
      if (product.featured_image) { const image = element('img', 'product-card__image'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; image.width = 853; image.height = 1280; imageLink.append(image); }
      const quick = element('a', 'quick-shop', cfg.strings.quick); quick.href = productURL(product.handle); quick.dataset.quickShop = product.handle;
      media.append(imageLink, quick); const info = element('div', 'product-card__info'); const title = element('h3'); const link = element('a', '', product.title); link.href = productURL(product.handle); title.append(link); info.append(title, element('div', 'price', money(product.price))); card.append(media, info); const buy = element(product.available ? 'a' : 'button', 'card-buy-now', product.available ? cfg.strings.buyNow : cfg.strings.sold); if (product.available) buy.href = productURL(product.handle); else { buy.type = 'button'; buy.disabled = true; } card.append(buy); grid.append(card);
    });
    scope.hidden = !grid.children.length;
  }
  function initReviews(scope = document) {
    scope.querySelectorAll('[data-review-fallback]').forEach(fallback => {
      if (fallback.dataset.reviewReady) return; fallback.dataset.reviewReady = 'true';
      const parent = fallback.parentElement;
      const update = () => { fallback.hidden = Boolean(parent.querySelector('.jdgm-rev-widg, .jdgm-rev-widg__body')); };
      update(); new MutationObserver(update).observe(parent, { childList: true, subtree: true });
    });
  }
  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  document.querySelectorAll('[data-recently-viewed]').forEach(initRecent);
  initReviews();
  function initRecommendations(scope) {
    if (scope.dataset.recommendationReady) return; scope.dataset.recommendationReady = 'true';
    async function load() {
      try {
        const response = await fetch(scope.dataset.url, { credentials: 'same-origin' }); if (!response.ok) return;
        const html = await response.text(); const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendation-result]');
        if (result?.querySelector('.product-card')) { scope.querySelector('[data-recommendation-result]').replaceWith(result); updateSavedButtons(); }
      } catch {}
    }
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { observer.disconnect(); load(); } }, { rootMargin: '300px' }); observer.observe(scope); }
    else load();
  }
  document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  function initSearch() {
    const input = document.getElementById('DialogSearch'); const container = document.querySelector('[data-predictive-results]');
    if (!input || !container) return;
    let timer; let controller; let sequence = 0; let activeIndex = -1;
    const close = () => { container.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); activeIndex = -1; };
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort(); const version = ++sequence; const query = input.value.trim(); close();
      if (query.length < 2) { container.replaceChildren(); return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '4', section_id: 'predictive-search' });
        try {
          const response = await fetch(`${root}search/suggest?${params}`, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) return;
          const html = await response.text(); if (version !== sequence) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-content]');
          if (!content) return;
          container.replaceChildren(content); container.hidden = false; input.setAttribute('aria-expanded', 'true');
        } catch (error) { if (error.name !== 'AbortError') close(); }
      }, 220);
    });
    input.addEventListener('keydown', event => {
      if (container.hidden) return;
      const options = [...container.querySelectorAll('[role="option"]')];
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
      else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault(); activeIndex = (activeIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === activeIndex)));
        input.setAttribute('aria-activedescendant', options[activeIndex].id); options[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && activeIndex >= 0) { event.preventDefault(); options[activeIndex].querySelector('a').click(); }
    });
    document.getElementById('SearchDialog')?.addEventListener('close', () => { clearTimeout(timer); controller?.abort(); ++sequence; close(); });
  }
  initSearch();
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.matches('[data-dialog-close]')) { target.closest('dialog')?.close(); }
    else if (target.matches('[data-search-open]')) { if (openDialog('SearchDialog')) { event.preventDefault(); document.getElementById('DialogSearch')?.focus(); } }
    else if (target.matches('[data-cart-open]')) { event.preventDefault(); showCart(); }
    else if (target.matches('[data-saved-open]')) { if (openDialog('WishlistDialog')) { event.preventDefault(); renderSaved(); } }
    else if (target.matches('[data-save-product]')) { event.preventDefault(); saveStyle(target.dataset.saveProduct); }
    else if (target.matches('[data-copy-code]')) {
      const code = target.dataset.copyCode;
      if (!navigator.clipboard?.writeText) { announce(cfg.strings.offerError); return; }
      navigator.clipboard.writeText(code).then(() => {
        target.textContent = cfg.strings.offerCopied; target.classList.add('is-copied'); announce(cfg.strings.offerCopiedCode.replace('{{ code }}', code));
        setTimeout(() => { target.textContent = cfg.strings.offerCopy; target.classList.remove('is-copied'); }, 2200);
      }).catch(() => announce(cfg.strings.offerError));
    }
    else if (target.matches('[data-offer-scroll]')) {
      const track = target.closest('.product-offers')?.querySelector('[data-offer-track]');
      if (track) track.scrollBy({ left: Number(target.dataset.offerScroll) * (track.querySelector('.offer-card')?.getBoundingClientRect().width + 12 || 230), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    else if (target.matches('[data-quantity-step]')) {
      const input = target.closest('.quantity-control')?.querySelector('input'); if (!input) return;
      const min = Number(input.min || 1); const step = Number(input.step || 1); const max = input.max ? Number(input.max) : Infinity;
      const next = Math.min(max, Math.max(min, Number(input.value || min) + Number(target.dataset.quantityStep) * step)); input.value = next; input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    else if (target.matches('[data-size-guide-open]')) {
      const guide = document.getElementById(target.dataset.sizeGuideOpen); if (guide) { event.preventDefault(); guide.open = true; guide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
    }
    else if (target.matches('[data-share-product]')) {
      const url = window.location.href; const title = target.dataset.shareTitle;
      if (navigator.share) navigator.share({ title, url }).catch(error => { if (error.name !== 'AbortError') announce(cfg.strings.shareError); });
      else if (navigator.clipboard?.writeText) navigator.clipboard.writeText(url).then(() => announce(cfg.strings.copied)).catch(() => announce(cfg.strings.shareError));
      else announce(cfg.strings.shareError);
    }
    else if (target.matches('[data-quick-shop]')) { event.preventDefault(); showQuickShop(target.dataset.quickShop); }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]'); if (!form) return;
    event.preventDefault(); addToCart(form);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-product-section]').forEach(initProduct); event.target.querySelectorAll('[data-recently-viewed]').forEach(initRecent); event.target.querySelectorAll('[data-recommendations]').forEach(initRecommendations); initReviews(event.target); updateSavedButtons();
  });
})();

